import { Country } from '@/router/fragments/fragment-items/Country';
import { CountryFilterOptionInformation } from '@studyportals/search-filters';
import { areasAvailableForCountry } from '@studyportals/static-domain-data/areas/areas-available-for-country';
import { countriesAll } from '@studyportals/static-domain-data/countries/countries';
import { countryGetByIsoCode } from '@studyportals/static-domain-data/countries/country-get-by-iso-code';
import { countryGetPath } from '@studyportals/static-domain-data/countries/country-get-path';
import { countryIsEea } from '@studyportals/static-domain-data/countries/country-is-eea';
import { countryGetDemonym } from '@studyportals/static-domain-data/countries/country-get-demonym';
import { countryGetById } from '@studyportals/static-domain-data/countries/country-get-by-id';

class CountryPresenter {
	public allWithPaths(): Country[] {
		const countries: Country[] = [];

		countriesAll.forEach((country) => {
			const path = countryGetPath(country.id);
			if (path === null) {
				return;
			}
			countries.push(new Country(country.id, path));
		});

		return countries;
	}

	public allOptions(): CountryFilterOptionInformation[] {
		return countriesAll.map(
			(country) =>
				new CountryFilterOptionInformation(
					country.name,
					country.id,
					'',
					'',
					areasAvailableForCountry(country.id),
					countryIsEea(country.id)
				)
		);
	}

	public idsOfIsoCodes(isoCodes: readonly string[]): string[] {
		const idsOfCountries = new Set<string>();

		for (const isoCode of isoCodes) {
			const country = countryGetByIsoCode(isoCode);
			if (country !== null) {
				idsOfCountries.add(country.id);
			}
		}

		return [...idsOfCountries];
	}

	public demonymOf(countryId: string): string | null {
		return countryGetDemonym(countryId);
	}

	public getCountryNameById(countryId: string): string | null {
		const foundCountry = countryGetById(countryId) || null;
		return foundCountry ? foundCountry.name : null;
	}

	public getCountrySlugById(countryId: string): string | null {
		return countryGetPath(countryId);
	}
}

const countryPresenterInstance = new CountryPresenter();

export { countryPresenterInstance as CountryPresenter };
